export default "__VITE_ASSET__BPPDM3Rx__"